import { FirebaseError } from "firebase/app"
import { onAuthStateChanged, signInWithEmailAndPassword, User, UserCredential } from "firebase/auth"
import { auth } from "@/config/firebase"

const signInWithEmail = (email: string, password: string): Promise<UserCredential> => {
  return signInWithEmailAndPassword(auth, email.trim(), password)
}

const subscribeToAuthState = (callback: (user: User | null) => void): (() => void) => {
  return onAuthStateChanged(auth, callback)
}

const getEmailSignInErrorMessage = (error: unknown): string => {
  if (error instanceof FirebaseError) {
    if (error.code === "auth/invalid-credential") {
      return "Invalid email or password"
    }

    return error.message ? `${error.code}: ${error.message}` : error.code
  }

  return error instanceof Error && error.message ? error.message : "Unable to sign in. Try again."
}

export { signInWithEmail, subscribeToAuthState, getEmailSignInErrorMessage }
